export default "__VITE_ASSET__HhYbAtmX__"